/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const MODBUSDEVICES = feature.getSettingValue('MODBUSDEVICES');
    if (!feature.getEnabled()) {
        return blocks;
    }
    const featureId = feature.getID();
    const MODBUS_DEVICE_COUNT = MODBUSDEVICES.length;
    const MASTER_SERIAL_PORT = feature.getSettingValue('MASTER_SERIAL_PORT');
    let callback_modbus_slave_reply = '';
    let setupCode = '';

    for (let i = 0; i < MODBUSDEVICES.length; i += 1) {
        const codeBlocks = MODBUSDEVICES[i].getCodeBlocks();
        const deviceId = MODBUSDEVICES[i].getID();
        for (let j = 0; j < codeBlocks.length; j += 1) {
            const block = codeBlocks[j];
            blocks = blocks.concat(block);
        }
    }

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
const ReadCoilStatus = 0x01;
const ReadInputStatus = 0x02;
const ReadHoldingRegisters = 0x03;
const ReadInputRegisters = 0x04;
const WriteSingleCoil = 0x05;
const PresetSingleRegister = 0x06;
        `,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function modbus_master_request(device_id, function_code, register_address, payload) {
    let device = simulator.context["${featureId}"][device_id];
    if (!device) {
        return;
    }
    const registerFeatureId = device[register_address];
    if (!registerFeatureId) {
        modbus_master_timeout(device_id, register_address);
        return;
    }
    if (function_code >= 5) {
        simulator.updateContext(registerFeatureId, {
            ["NAME"]: payload,
            });
    }
    const registerValue = simulator.context[registerFeatureId]["NAME"];
    callback_modbus_slave_reply(device_id, register_address, registerValue);
    return;
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function modbus_master_timeout(device_id, register_address) {
    /****callback_modbus_slave_reply_timeout****/
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function callback_modbus_slave_reply(device_id, register_address, response_data) {
    /****callback_modbus_slave_reply****/
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function modbus_proc_timer() {
    /****modbus_proc_timer****/
}`,
    });

    blocks.push({
        location: 'var_poll_timer_elapsed',
        blockType: BlockType.CODE,
        template: `
modbus_proc_timer();
`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext("${featureId}", {
    /****modbus_master_request_devices_init****/
});
    `,
    });

    return blocks;
};
